import styled from 'styled-components';
import { StyledDrawerLink } from '../DrawerLink/styled';

export const StyledDrawerExit = styled(StyledDrawerLink).attrs({
  as: 'button',
})``;
